var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nav-button--search",attrs:{"aria-label":_vm._f("t")('Search')},on:{"click":function($event){return _vm.toggleSearch()}}},[(!_vm.search)?_c('i',{staticClass:"fas fa-search"}):_c('i',{staticClass:"fas fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }